module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\nin vec2 fs_UV;\r\n\r\nout vec4 out_Col;\r\n\r\nuniform vec2 u_Resolution;\r\nuniform sampler2D u_frame;\r\nuniform float u_Threshold;\r\n\r\n\r\nvoid main() {\r\n\tvec4 col = texture(u_frame, fs_UV);\r\n\tfloat minT = max(u_Threshold - 1.0, 0.0);\r\n\tfloat brightness = dot(col.rgb, vec3(0.213, 0.715, 0.072));\r\n\tfloat t = clamp((brightness - minT) / (u_Threshold - minT + 0.01), 0.0, 1.0);\r\n\tt = t * t * (3.0 - 2.0 * t);\r\n\t//t = 1.0;\r\n\tout_Col = vec4(t * col.rgb, 1.0);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/highpass-frag.glsl
// module id = 43
// module chunks = 0